import Layout from '../components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { AlertTriangle } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-secondary py-12" data-testid="impressum-page">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex items-start gap-3 bg-amber-50 border border-amber-300 text-amber-900 rounded-lg p-4 mb-6">
            <AlertTriangle className="h-5 w-5 mt-0.5 flex-shrink-0" />
            <p className="text-sm">
              <strong>Platzhalter — rechtlich noch zu prüfen.</strong> Dieses Impressum ist ein
              Entwurf und enthält noch keine verbindlichen Angaben. Es darf erst veröffentlicht
              werden, nachdem die eckigen Platzhalter durch die tatsächlichen Unternehmens- und
              Registerdaten ersetzt und von einem Rechtsanwalt geprüft wurden.
            </p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle className="font-serif text-3xl">Impressum</CardTitle>
            </CardHeader>
            <CardContent className="prose prose-sm max-w-none">
              <h2>Angaben gemäß § 5 TMG</h2>
              <p>
                [Vollständiger Firmenname, z. B. WEDVAYA GmbH]<br />
                [Straße und Hausnummer]<br />
                [PLZ und Ort]<br />
                [Land]
              </p>

              <h2>Vertreten durch</h2>
              <p>[Name der Geschäftsführung / vertretungsberechtigten Person(en)]</p>

              <h2>Kontakt</h2>
              <p>
                Telefon: [Telefonnummer]<br />
                E-Mail: kontakt@wedvaya.com
              </p>

              <h2>Registereintrag</h2>
              <p>
                Eintragung im Handelsregister.<br />
                Registergericht: [Registergericht]<br />
                Registernummer: [HRB-Nummer]
              </p>

              <h2>Umsatzsteuer-ID</h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                [USt-IdNr.]
              </p>

              <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
              <p>
                [Name, Anschrift wie oben]
              </p>

              <h2>Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr/</a>.
                Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht verpflichtet und
                nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
                teilzunehmen. [Angabe final mit Rechtsberatung abstimmen.]
              </p>

              <h2>Haftungsausschluss</h2>
              <p>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die
                Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich
                deren Betreiber verantwortlich.
              </p>

              <p className="text-sm text-muted-foreground mt-8">
                Entwurf — nicht veröffentlicht
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default ImpressumPage;
